import { HOMETAB_EVENTS } from '@/utility/analyticsConsts';
import { t } from '@/utility/localization';
import {
  CM_PORTAL_ADD_NEW_EVENT_ROUTE,
  CM_PORTAL_CHALLENGES_NEW_PAGE_ROUTE,
  CM_PORTAL_FEED_PAGE_ROUTE,
  CM_PORTAL_LIBRARY_PAGE_ROUTE,
  CREATE_MAGIC_REACH_ROUTE
} from '@/utility/routesHelper';

export const getCreateDropdownMenuOptions = () => [
  {
    type: 'magic-reach',
    title: t('magic-reach'),
    icon: 'send-magic-01',
    link: CREATE_MAGIC_REACH_ROUTE,
    gaEventId: HOMETAB_EVENTS.CREATE__MAGIC_REACH_CLICK
  },
  {
    title: t('product'),
    icon: 'rows-01',
    link: `${CM_PORTAL_LIBRARY_PAGE_ROUTE}?openCreateProduct=true`,
    gaEventId: HOMETAB_EVENTS.CREATE_CONTENT_CLICK
  },
  {
    title: t('event'),
    icon: 'calendar',
    link: CM_PORTAL_ADD_NEW_EVENT_ROUTE,
    gaEventId: HOMETAB_EVENTS.CREATE_EVENT_CLICK
  },
  {
    title: t('post'),
    icon: 'announcement-03',
    link: `${CM_PORTAL_FEED_PAGE_ROUTE}?openNewEditor=true`,
    gaEventId: HOMETAB_EVENTS.CREATE_CHALLENGE_CLICK
  },
  {
    title: t('challenges'),
    icon: 'trophy-01',
    link: CM_PORTAL_CHALLENGES_NEW_PAGE_ROUTE,
    gaEventId: HOMETAB_EVENTS.CREATE_CHALLENGE_CLICK
  }
];

export default () => {
  const getLegendsCommunityCardProps = (link) => ({
    title: t('learn-from-community-builders'),
    description: t('join-our-community-of-experts'),
    iconName: 'nas-io-logo-coloured',
    iconPath: 'logo',
    iconColorClass: '',
    link: link,
    iconBackgroundClass: ''
  });

  const helpCenterCardProps = {
    title: t('help-center'),
    description: t('discover-the-best-community-practices'),
    iconName: 'lightbulb-02',
    iconSize: 16,
    iconColorClass: 'stroke-npl-yellow-light-solid-11',
    iconBackgroundClass: 'bg-npl-yellow-light-solid-5',
    link: 'https://help.nas.io'
  };

  const MEMBERSHIP_COUNT_INTERVAL = 'last_30_days';

  const EARNINGS_STATES = {
    NO_PAID_COMM_AND_ENTITY: 'NO_PAID_COMM_AND_ENTITY',
    HAVE_PAID_COMMU_OR_ENTITY: 'HAVE_PAID_COMMU_OR_ENTITY',
    NO_SALES_THIS_MONTH: 'NO_SALES_THIS_MONTH'
  };
  return {
    MEMBERSHIP_COUNT_INTERVAL,
    EARNINGS_STATES,
    getLegendsCommunityCardProps,
    helpCenterCardProps
  };
};
